import { CommunityURlPrefix } from 'src/envReader';

export const discoveryUrl = CommunityURlPrefix + 'discovery/api';
export const authUrl = CommunityURlPrefix + 'oceanauth/api';
export const exporterUrl = CommunityURlPrefix + 'oceanexporter/api';
export const coreUrl = CommunityURlPrefix + 'oceancore/api';
export const schedulerUrl = CommunityURlPrefix + 'oceanscheduler/api';
